import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import DatePicker from "react-multi-date-picker";
import { display, height } from '@mui/system';
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import axios from 'axios';
import moment from 'moment';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const HoldSubscription = ({ show, onClose, data, refresh }) => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;


    // Input values
    
    const [holdReason, setHoldReason] = useState('');
    const [allDates, setAllDates] = useState([]);
    
    const formatName = (name) => {
        return name.charAt(0).toUpperCase() + name.slice(1);
    };

    const [startDate, setStartDate] = useState(null);
    const [timeline, setTimeline] = useState(null);
    const [alldays, setAlldays] = useState(null);
    const [holdcount, setHoldcount] = useState(null);
    const [timelinerelation, settimeline] = useState([]);

    const [minDate, setMinDate] = useState(null);
    const [maxDate, setMaxDate] = useState(null);
    const [holdDates, setHoldDates] = useState([]);

    useEffect (() => {
        if (data) {
            setStartDate(data.start_date);
            setTimeline(data.timelinerelation);
            setAlldays(data.timelinerelation.all_days);
            setHoldcount(data.hold_count);
            settimeline(data.timelinerelation);
            setMinDate(new Date(data.start_date));
            setMaxDate(new Date(data.end_date));
            const rawHoldDates = data.hold_dates;
            if (rawHoldDates) {
                // Split the string into an array if it's not null
                setHoldDates(rawHoldDates.split(','));
            } else {
                // Set an empty array if it's null
                setHoldDates([]);
            }
        }
    }, [data]);

    // Holiday array
    const [holidays, setHolidays] = useState([]);
    useEffect(() => {
        const fetchdata = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/getholiday`);
                setHolidays(response.data.data);
                const holidayDates = response.data.data;
                const formattedHolidays = holidayDates.map(date =>
                    moment(date, 'YYYY-MM-DD').format('DD-MM-YYYY')
                );

                // Append to holdDates and remove duplicates
                setHoldDates(prev => Array.from(new Set([...prev, ...formattedHolidays])));

            } catch (error) {
                console.log('Error fetching data', error);
            }
        };

        fetchdata();
    }, []);

    const [endDate, setEndDate] = useState(null);
    const calculateEndDate = (timeline, startDate, count, holdcount, holidays = []) => {
        const all_days = timeline.all_days;
        const days_count = timeline.days + count + holdcount;
        let sunday, monday, tuesday, wednesday, thursday, friday, saturday;
        if ( all_days === 1) {
            sunday = timeline.sunday;
            monday = timeline.monday;
            tuesday = timeline.tuesday;
            wednesday = timeline.wednesday;
            thursday = timeline.thursday;
            friday = timeline.friday;
            saturday = timeline.saturday;
        } else {
            sunday = '0';
            monday = '0';
            tuesday = '0';
            wednesday = '0';
            thursday = '0';
            friday = '0';
            saturday = '0';
        }

        // Create a days array that represents the days of the week (0 = Sunday, 6 = Saturday)
        const daysOfWeek = [sunday, monday, tuesday, wednesday, thursday, friday, saturday];
        // console.log(daysOfWeek);
    
        let currentDate = moment(startDate);
        let validDaysCount = 0;
    
        // Loop until we've counted the required days (excluding invalid ones like Sundays)
        while (validDaysCount < days_count) {
            // console.log(validDaysCount, days_count);

            // Check if the current day is valid to count (i.e., its value is 1)
            const currentDayOfWeek = currentDate.day();
            // console.log(currentDate, currentDate.day());

            const currentDateStr = currentDate.format('YYYY-MM-DD');

            const isHoliday = holidays.includes(currentDateStr);
            const isValidDay = daysOfWeek[currentDayOfWeek] === '0';
            // console.log(currentDateStr, isHoliday, isValidDay);

            if (isValidDay && !isHoliday) {
                validDaysCount++;
            }
            
            // if (daysOfWeek[currentDayOfWeek] === '0') {
            //     validDaysCount++;
            // }
    
            // Move to the next day
            currentDate.add(1, 'days');
        }
        const endDate = currentDate.format('YYYY-MM-DD');
        // console.log(endDate);
        setEndDate(endDate);
        return endDate;
    };

    // add hold
    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};
        console.log(allDates);
        if (!allDates || allDates.length === 0) {
            newErrors.alldate = "This Field is Required.";
        }

        if (!holdReason) {
            newErrors.reason = "This Field is Required.";
        }
        console.log(newErrors);
        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        let date = null
        let count = 0
        let enddat = null;
        date = allDates.join(',');
        count = allDates.length;
        enddat = calculateEndDate(timeline, startDate, count, holdcount, holidays);
        

        const postData = {
            hold_type: 0,
            hold_dates: date,
            hold_reason: holdReason,
            hold_count: count,
            end_date: enddat
        }
        // console.log(postData);

        axios.put(`${baseURL}/leadsubscription/hold/${data.sno}`, postData)
            .then(response => {
                onClose();
                refresh();
                toast.success("Subscription Updated Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Subscription Updation Failed");
            });
    };

    return (
        <Modal show={show} size="md"  >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Hold Subscriptions</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                <label className='text-gray-800 font-w500 fs-7'>Subscriber</label>
                                <label className='text-black fs-6 font-w500'>{data.lead_name}</label>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                <label className='text-gray-800 font-w500 fs-7'>Mobile No</label>
                                <label className='text-black fs-6 font-w500'>{data.lead_mobile_no}</label>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                <label className='text-gray-800 font-w500 fs-7'>Product</label>
                                <label className='text-black fs-6 font-w500'>{data.product_name}</label>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                <label className='text-gray-800 font-w500 fs-7'>Timeline</label>
                                <label className='text-black fs-6 font-w500'>{data.timeline_name} ({data.timeline_days} Days)</label>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                <label className='text-gray-800 font-w500 fs-7'>Days</label>
                                <label className='text-black fs-6 font-w500'>
                                    {timelinerelation.all_days === 0
                                        ? 'All Days'
                                        : [
                                            timelinerelation.monday === "0" && 'Mon',
                                            timelinerelation.tuesday === "0" && 'Tue',
                                            timelinerelation.wednesday === "0" && 'Wed',
                                            timelinerelation.thursday === "0" && 'Thu',
                                            timelinerelation.friday === "0" && 'Fri',
                                            timelinerelation.saturday === "0" && 'Sat',
                                            timelinerelation.sunday === "0" && 'Sun',
                                        ]
                                        .filter(Boolean)
                                        .join(', ')
                                    }
                                </label>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                <label className='text-gray-800 font-w500 fs-7'>Area</label>
                                <label className='text-black fs-6 font-w500'>{data.area_name}</label>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                <label className='text-gray-800 font-w500 fs-7'>Delivery Point</label>
                                <label className='text-black fs-6 font-w500'>{data.deliverypoint_name}</label>
                            </div>
                            <div className='col-lg-12 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                <label className='text-gray-800 font-w500 fs-7'>Address</label>
                                <label className='text-black fs-6 font-w500'>{data.address ? data.address : '-'}</label>
                            </div>
                            
                            <div className="col-lg-12 mb-3">
                                <label className="text-black font-w500 fs-7">Hold Date<span className="required">*</span></label>
                                <div className='datepicker-wrapper d-flex'>
                                    <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                    <DatePicker placeholder='Select Hold Date' multiple
                                        format="DD-MM-YYYY"
                                        className="date-picker-wrapper"
                                        minDate={minDate} // Restrict to start date
                                        maxDate={maxDate} // Restrict to end date

                                        mapDays={({ date }) => {
                                            // console.log(date);

                                            const isDisabledFromHoldDates = holdDates.some((disabledDateStr) => {
                                                const [day, month, year] = disabledDateStr.split('-').map(Number);
                                                return (
                                                    date.day === day &&
                                                    date.month.number === month &&
                                                    date.year === year
                                                );
                                            });

                                            // If holdDates matched, disable the date
                                            if (isDisabledFromHoldDates) {
                                                return {
                                                    disabled: true,
                                                    style: { color: "#ccc" },
                                                };
                                            }

                                            // Check for weekday restrictions only if all_days === 1
                                            if (timelinerelation.all_days === 1) {
                                                // Get the day of the week (0 = Sunday, 6 = Saturday)
                                                const dayOfWeek = date.weekDay.index; // Some date libraries use `weekday.index`

                                                const dayMap = [
                                                    'sunday',
                                                    'monday',
                                                    'tuesday',
                                                    'wednesday',
                                                    'thursday',
                                                    'friday',
                                                    'saturday'
                                                ];

                                                const dayName = dayMap[dayOfWeek];

                                                if (timelinerelation[dayName] === "1") {
                                                    return {
                                                        disabled: true,
                                                        style: { color: "#ccc" },
                                                    };
                                                }
                                            }

                                            // Otherwise, return nothing (date is enabled)
                                            return;
                                        }}



                                        // mapDays={({ date }) => {
                                        //     const isDisabled = holdDates.some((disabledDateStr) => {
                                        //         const [day, month, year] = disabledDateStr.split('-').map(Number);
                                        //         console.log(date, date.day, day, month, year);
                                        //         return (
                                        //             date.day === day &&
                                        //             date.month.number === month &&
                                        //             date.year === year
                                        //         );
                                        //     });
                                        //     // console.log(isDisabled);
                                        //     if (isDisabled) {
                                        //         return {
                                        //         disabled: true,
                                        //         style: { color: "#ccc" }, // Optional: Style disabled dates
                                        //         };
                                        //     }
                                        // }}

                                        onChange={(dates) => {
                                            const formatted = dates.map(d => d.format("DD-MM-YYYY"));
                                            // console.log(formatted);
                                            setAllDates(prev => {
                                                const sorted = formatted.sort((a, b) =>
                                                    moment(a, "DD-MM-YYYY").toDate() - moment(b, "DD-MM-YYYY").toDate()
                                                );
                                                return sorted;
                                            });
                                        }}
                                        plugins={[<DatePanel />]}
                                    />
                                </div>
                                {errors.alldate && <div className="text-danger fs-8 mt-1">{errors.alldate}</div>}
                            </div>
                            
                            <div className="col-lg-12 mb-4">
                                <label className="text-black font-w500 fs-7">Reason<span className="required">*</span></label>
                                <textarea className="form-control" placeholder="Enter Reason"
                                    maxLength={250}
                                    value={holdReason} 
                                    onChange={(e) => setHoldReason(formatName(e.target.value))} 
                                />
                                {errors.reason && <div className="text-danger fs-8 mt-1">{errors.reason}</div>}
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                            {/* <Link className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link> */}
                            <button className="btn btn-sm btn-primary" >Update Hold Subscriptions<i className="fas fa-angle-double-right ms-2"></i></button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
};

export default HoldSubscription;
